/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-26 19:36.
 */
class ZcyWuhaiFullTextSearch {

}

module.exports = ZcyWuhaiFullTextSearch;
